<template>
  <div class="article-detail-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header class="top-title" v-if="!isWechatBrowser" title="评论详情" :showBack="true"></my-header>
    <div class="user-info">
        <img class="user-avatar-url" :src="answer.avatarUrl">
        <div style="width: 6rem">
          <div class="user-name">{{answer.userName}}
            <img class="icon-reply-btn" @click="commentUser(answer.id,answer.userId,answer.userName,'')" src="../../assets/icon/icon-reply-btn.png">
          </div>
          <div class="create-time">{{answer.createTime | time}}</div>
          <div class="answer-content">{{answer.content}}</div>
          <div v-if="answer.replyList" class="reply-part">
              <div v-for="(reply,index) in answer.replyList" @click="commentUser(answer.id,reply.userId,reply.userName,reply.id)"><span class="user-nickname" style="color: #1d8ae7">{{reply.userName}}: @{{reply.replyUserName}}</span> {{reply.content}}</div>
          </div>
        </div>
    </div>
    <div class="border-top-style comment-footer-part">
      <div v-if="isReplyOperate">
        <div v-if="isReply" class="comment-container">
          <textarea v-focus class="qa-detail-text" v-model="content"  rows="3" :placeholder="placeholderText"></textarea>
          <div style="display: flex;justify-content: flex-end">
            <div class="cancel-comment-btn" @click="cancelReply">取消</div>
            <div class="send-comment-btn" @click="saveReply">发送</div>
          </div>
        </div>

      </div>
    </div>
    <div v-if="isComment || isReply" class="general-box-bg"></div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import answerService from '../../service/qa/AnswerService'
  import {imgUrl} from "../../config";

  export default {
    name: 'AnswerDetail',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imgUrl: imgUrl,
        questionId:'',
        answerId:'',
        content:'',
        question:{quImages:[]},
        answer:{},
        isReplyOperate:false,
        isReply:false,
        isComment:false,
        showCancel:true,
        isWechatBrowser:this.$verfyBrowserType(),
        showImage:'',
        showBig:false,
        previewImageList:[],
        placeholderText:'评论',
        replyedUserId:'',
        replyId:''
      }
    },
    created(){
      this.questionId = this.$route.query.questionId;
      this.answerId = this.$route.query.answerId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getAnswerDetail();
    },
    directives: {
      focus: {
        // 指令的定义
        inserted: function (el) {
          el.focus()
        }
      }
    },
    watch:{
//      content(value){
//        if (value) {
//          this.showCancel = false;
//        } else {
//          this.showCancel = true;
//        }
//      }
    },
    methods: {
      async getAnswerDetail(){
        let {code,msg,data} = await answerService.detail(this.answerId);
        if(code == '0'){
          this.answer = data;
        }else {
          Toast(msg);
        }
      },
      beforeComment(){
        this.isComment = true;
        this.placeholderText = '@' + this.question.userName;
      },
      cancelComment(){
        this.isComment = false;
        this.content = '';
      },
      async saveComment(){
        if(!this.content){
          Toast('请输入评论内容');
          return false;
        }
        let answer = {questionId:this.questionId,content:this.content,type:'1'};
        let {code,msg,data} = await answerService.save(answer);
        if(code == '0'){
          Toast('评论成功!');
          this.answerList = [];
          this.getAnswerDetail();
          this.content = '';
          this.isComment = false;
        }else {
          Toast('评论失败!');
        }
      },
      commentUser(answerId,userId,userName,replyId){
        console.info(replyId)
        this.answerId = answerId;
        this.replyedUserId = userId;
        this.replyId = replyId;
        this.isReplyOperate = true;
        this.isReply = true;
        this.placeholderText = '回复给'+userName;
      },
      cancelReply(){
        this.isReply = false;
        this.content = '';
        this.isReplyOperate = false;
      },
      async saveReply(){
        if(!this.content){
          Toast('请输入回复内容');
          return false;
        }
        let answer = {questionId:this.questionId,replyUserId:this.replyedUserId,answerId:this.answerId,content:this.content,type:'2',replyId:this.replyId};
        console.info(answer)
        let {code,msg,data} = await answerService.save(answer);
        if(code == '0'){
          Toast('回复成功!');
          this.answerList = [];
          this.getAnswerDetail();
            this.isReply = false;
            this.answerId = '';
            this.content = '';
            this.isReplyOperate = false;
        }else {
          Toast('回复失败!');
        }
      },
      showBigImg(contract){
        this.showImage = this.imgUrl + contract;
        this.showBig = true;
      },
      previewImg(currentImage,previewImageList){
        wx.previewImage({
          current: currentImage, // 当前显示图片的http链接
          urls: previewImageList // 需要预览的图片http链接列表

        });
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .article-detail-page {
    padding-bottom: 1.5rem;
    font-size: 0.28rem;
    text-align: left;
    .user-info{
      padding: 0.3rem;
      display: flex;
      .user-avatar-url{
        flex-shrink: 0;
        width: 0.92rem;
        height: 0.92rem;
        border-radius: 0.92rem;
        margin-right: 0.28rem;
      }
      .user-name{
        font-size: 0.32rem;
        color: #1b1e29;
        padding-bottom: 0.1rem;
        position: relative;
        .icon-reply-btn{
          width: 0.33rem;
          height: 0.32rem;
          position: absolute;
          right: 0.1rem;
          top: 0.1rem
        }
      }
      .answer-content{
        width: 5.8rem;
      }
      .reply-part{
        margin-top: 0.1rem;
        padding: 0.2rem;
        background-color: #f3f8fc;
        font-size: 0.24rem;
        color: #878e99;
      }
      .create-time{
        font-size: 0.24rem;
        color: #d5dee2;
      }
    }
  .before-search-part{
    width: 6.92rem;
    height: 0.62rem;
    line-height: 0.62rem;
    margin: 0.2rem auto;
    padding-left: 0.22rem;
    font-size: 0.24rem;
    color: #878e99;
    background: #f3f8fc;
  }
  .search-part{
    width: 5.4rem;
    height: 0.62rem;
    line-height: 0.62rem;
    margin: 0.2rem 0.3rem 0.2rem;
    padding-left: 0.2rem;
    font-size: 0.24rem;
    color: #878e99;
    background: #f3f8fc;
  .article-search-input{
    width: 5rem;
    background: #f3f8fc;
    color: #1b1e29;
    line-height: 0.4rem;
  }
  }
  .cancel-comment-btn{
    color: #878e99;
    font-size: 0.28rem;
    line-height: 0.76rem;
    margin-right: 0.5rem;
  }
  .send-comment-btn{
    font-size: 0.28rem;
    line-height: 0.76rem;
    color: #26a2ff;
    text-align: right;
  }
  .comment-footer-part{
    position: fixed;
    bottom: 0rem;
    background: white;
    width: 100%;
    z-index: 1002
  }
  .comment-container{
    z-index: 1002;
    width: 6.92rem;
    margin: 0.28rem auto 0rem auto;
  }
    .qa-detail-text{
      background: #f3f8fc;
      width: 100%;
      padding: 0.1rem;
      font-size: 0.28rem;
      resize:none
    }
  }
</style>
